/* @refresh reset */
import './libs/sentry' // Initialize Sentry first
import { createRoot } from 'react-dom/client'
import { Toaster } from 'react-hot-toast'
// Initialize Firebase BEFORE i18n to ensure FirebaseBackend can access it
import './libs/Firebase'
import App from './App.tsx'
import './index.css'
import './i18n' // Initialize i18n
import { isAgentModeEnabled } from './agentTesting/agentMode'
import { installVitePreloadErrorRecovery } from './libs/onUnhandledPromiseRejection'

installVitePreloadErrorRecovery()

// AI-agentic-testing layer (dev builds + ?agentMode=true only). Must install before any
// Whereby join so the synthetic mic patch is in place; dynamic import keeps it out of the
// main chunk for everyone else.
if (isAgentModeEnabled()) {
  void import('./agentTesting/installAgentApis').then((m) => m.installAgentApis())
}

if (typeof window !== 'undefined') {
  const win = window as typeof window & { global?: typeof window }
  if (!win.global) {
    win.global = window
  }
}

// Loading fallback shown while translations load
// eslint-disable-next-line react-refresh/only-export-components
const LoadingFallback = () => (
  <div
    style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      backgroundColor: '#000000',
      width: '100%',
      margin: 0,
      padding: 0
    }}
  >
    <div style={{ textAlign: 'center' }}>
      <div
        style={{
          display: 'inline-block',
          width: '48px',
          height: '48px',
          border: '4px solid #fbbf24',
          borderTopColor: 'transparent',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite'
        }}
      />
      <style>{`
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      `}</style>
      <p style={{ marginTop: '16px', color: '#ffffff', fontSize: '18px' }}>Loading</p>
    </div>
  </div>
)

// Show loading spinner immediately while waiting for translations
const rootElement = document.getElementById('root')!
const root = createRoot(rootElement)

// Render loading spinner first
root.render(<LoadingFallback />)

// Render app immediately - FirebaseBackend will load local translations instantly on-demand
// This eliminates any loading delay since local translations are instant
// Suspense wrapper removed - not needed since i18n.useSuspense is false and static pages don't need lazy loading
root.render(
  <>
    <App />
    <Toaster
      position="top-right"
      toastOptions={{
        style: {
          background: 'var(--brand-primary)',
          color: 'white'
        }
      }}
    />
  </>
)
